export enum ElementType {
  Text,
  Button,
}
